import React from "react";

/**
 * Props:
 *  - bgLabel: Arka planda büyük etiket (örn: yıl, kısa metin, vs)
 *  - calligraphy: El yazısı/özel yazı (örn: slogan)
 *  - title: Üst başlık (küçük)
 *  - highlight: Büyük kalın ana başlık
 *  - children: Açıklama veya içerik (her türlü JSX)
 *  - className: (opsiyonel) ek CSS class
 */
export default function HighlightBlock({
  bgLabel,
  calligraphy,
  title,
  highlight,
  children,
  className = ""
}) {
  return (
    <section className={`highlight-block ${className}`}>
      {bgLabel && <div className="highlight-block__bg-label">{bgLabel}</div>}
      {calligraphy && <div className="highlight-block__calligraphy">{calligraphy}</div>}
      <div className="highlight-block__main">
        {title && <div className="highlight-block__title">{title}</div>}
        {highlight && <div className="highlight-block__highlight">{highlight}</div>}
        <div className="highlight-block__desc">{children}</div>
      </div>
    </section>
  );
}
